<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Citas Pendientes</v-toolbar-title>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader
                                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-else>
                        <v-col cols="12" md="7">
                            <div>
                                <div class="mt-4">
                                    <span class="type-label-style">Fecha inicial:</span>
                                </div>
                                <v-dialog ref="dialogfhini" outlined v-model="modalfhini"
                                    :return-value.sync="selectedDateIni" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field class="pt-2" v-model="selectedDateIni" label="" outlined dense
                                                v-bind="attrs" v-on="on" readonly>
                                            </v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="selectedDateIni" locale="es" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="secondary" @click="modalfhini = false">Cancelar</v-btn>
                                        <v-btn text color="primary" @click="saveDateIni(selectedDateIni)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                                <span v-if="validafechaini" class='spanError' style='color:red;font-size:11px'>Campo
                                    requerido</span>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div>
                                <div class="mt-1">
                                    <span class="type-label-style">Fecha final:</span>
                                </div>
                                <v-dialog ref="dialogfhfin" outlined v-model="modalfhfin"
                                    :return-value.sync="selectedDateFin" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field class="pt-2" v-model="selectedDateFin" label="" outlined dense
                                                v-bind="attrs" v-on="on" readonly>
                                            </v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="selectedDateFin" :min="selectedDateIni" locale="es" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="secondary" @click="modalfhfin = false">Cancelar</v-btn>
                                        <v-btn text color="primary" @click="$refs.dialogfhfin.save(selectedDateFin)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                                <span v-if="validafechafin" class='spanError' style='color:red;font-size:11px'>Campo
                                    requerido</span>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-4">
                                <span class="type-label-style">Estatus:</span>
                                <multiselect v-model="tipoEstatus.ciestatus"
                                    deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                                    select-label="Seleccione un estado de cita" track-by="ciestatus" label="cinombre"
                                    placeholder="Todo" :options="tipoEstatus.opcionesEstatus" :allow-empty="false">
                                </multiselect>
                            </div>
                            <div class="mt-4">
                                <span class="type-label-style">Tipo Cita:</span>
                                <multiselect v-model="tipoCita.tpcclave"
                                    deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                                    select-label="Seleccione tipo de cita" track-by="tpcclave" label="tpcnombre"
                                    placeholder="Todo" :options="tipoCita.opcionesCita" :allow-empty="false">
                                </multiselect>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" @click="Buscar()"
                        :disabled="disBtn">Buscar</v-btn>
                    <v-btn class="ma-2" color="default" :disabled="disBtn" @click="limpiar()">Limpiar</v-btn>
                    <v-btn class="ma-2" color="error" @click="cancelar()" :disabled="disBtn">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card v-if="mostrarReportes">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Resultados</v-toolbar-title>
                <v-spacer></v-spacer>
                <template>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-on="on" v-bind="attrs" icon fab dark @click="DescargarExcel()"
                                :disabled="disabledExcel">
                                <v-icon dark style="cursor: pointer !important" class="hover">
                                    mdi-file-excel-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
                </template>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12">
                        <DataTable :url="url" :columns="columnasReporte" :params="displayInputsReportes"
                            :formatterActions="formatterActionsCitas" @apiDT="apiDT = $event" :order="[]"
                            @cargando="valCargando">
                        </DataTable>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>

import { mapMutations, mapState } from 'vuex';
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import UtilidadesServ from '@/services/Utilidades/Utilidades.service.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import moment from 'moment'
import xlsxPopulate from 'xlsx-populate';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        Menu,
        DataTable,
        xlsxPopulate,
    },
    data() {
        return {
            loaded: true,
            modalfhini: false,
            modalfhfin: false,
            selectedDateIni: null,
            selectedDateFin: null,
            validForm: true,
            disBtn: false,
            permisoExpJur: false,
            tipoCita: {
                opcionesCita: [],
                tpcclave: '',
                tpcnombre: '',
            },
            validafechaini: false,
            validafechafin: false,
            tipoEstatus: {
                opcionesEstatus: [],
                ciestatus: '',
                cinombre: '',
            },
            url: "Utilidades/CitasReportes",
            displayInputsReportes: {
                fhcita: '',
                fhfincita: '',
                estatus: '',
                tipo: 0
            },
            columnasReporte: [
                { name: 'Reporte', data: 'reporte', title: "Reporte", formatter: [this, "reporteForm"], },
                { name: 'Cliente', data: 'cliente', title: "Cliente" },
                { name: 'Gerente', data: 'genombre', title: "Gerente" },
                { name: 'Supervisor', data: 'sunombre', title: "Supervisor" },
                { name: 'Proveedor', data: 'prnombre', title: "Proveedor" },
                { name: 'Fecha de cita', data: 'cifhcita', title: "Fecha de cita" },
                { name: 'Comentario', data: 'cicomentario', title: "Comentario" },
            ],
            formatterActionsCitas: [
                { click: [this, "BuscarDetalleCita"] },
            ],
            apiDT: null,
            mostrarReportes: false,
            showcargando: false,
            listado: '',
            nombreArchivo: '',
            disabledExcel: true,
        };
    },
    watch: {
        'selectedDateIni'(val) {
            this.validafechaini = val != null ? false : true;
        },
        'selectedDateFin'(val) {
            this.validafechafin = val != null ? false : true;
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '28').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 28)//Permiso para ExpJur
                        this.permisoExpJur = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        await UtilidadesServ.obtenerTipoCita(this);
        await UtilidadesServ.ObtenerEstatus(this);
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        handleCopy(event) {
            event.preventDefault();
        },
        saveDateIni(selectedDateIni) {
            this.$refs.dialogfhini.save(selectedDateIni);
            this.selectedDateFin = '';
        },
        cancelar() {
            this.$router.push({ name: `Menu` });
        },
        limpiar() {
            this.selectedDateIni = '';
            this.selectedDateFin = '';
            this.tipoCita.tpcclave = '';
            this.tipoEstatus.ciestatus = '';
            this.validafechaini = false;
            this.validafechafin = false;
            this.mostrarReportes = false;
            this.disabledExcel = true;
        },
        async Buscar() {
            this.ValidacionFormulario();
            if (this.validafechaini == false && this.validafechafin == false) {
                this.mostrarReportes = true;
                this.disabledExcel = true;
                this.displayInputsReportes = {
                    fhcita: this.selectedDateIni,
                    fhfincita: this.selectedDateFin,
                    estatus: this.tipoEstatus.ciestatus == "" ? null : this.tipoEstatus.ciestatus.ciestatus,
                    tipo: this.tipoCita.tpcclave == "" ? 0 : this.tipoCita.tpcclave.tpcclave
                },
                    await this.reloadTable();
            }
        },
        ValidacionFormulario() {
            this.validafechaini = (this.selectedDateIni == null || this.selectedDateIni == '') ? true : false;
            this.validafechafin = (this.selectedDateFin == null || this.selectedDateFin == '') ? true : false;
        },
        async BuscarDetalleCita(params, item, fila) {
            let reporte = {
                nrreporte: item.reporte,
                svindice: item.indice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", item.reporte);
            formData.append("svindice", item.indice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });

            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` });
            }
            else {
                let asistenciaurl = await MetodosGenerales.ObtenerURL(reporte);
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ path: asistenciaurl + '/Reporte/Citas' });

            }
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        reporteForm(datos) {
            if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {
                return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.reporte}-${datos.indice}</span></button></div>`;
            } else {
                return `<span>${datos.reporte}-${datos.indice}</span>`;
            }
        },
        async DescargarExcel() {
            this.showcargando = true;
            let today = moment().format('yyyy-MM-DD');
            this.nombreArchivo = 'Citas_Pendientes_' + today.toString();
            let estatus = this.tipoEstatus.ciestatus == "" ? null : this.tipoEstatus.ciestatus.ciestatus;
            let tipo = this.tipoCita.tpcclave == "" ? 0 : this.tipoCita.tpcclave.tpcclave;
            const response = await UtilidadesServ.CitasReportesExcel(this.selectedDateIni, this.selectedDateFin, estatus, tipo);
            await MetodosGenerales.exportToExcel(response, this.nombreArchivo, false, true);
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'Utilidades');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", 'Citas Pendientes');
            formData.append("lanombre", this.nombreArchivo + ".xlsx");
            formData.append("ladestinatario", " ");
            await UtilidadesServ.AlmacenarVisitas(formData);
            this.showcargando = false;
        },
        valCargando() {
            this.disabledExcel = this.apiDT.data().length > 0 ? false : true;
        }
    }
}
</script>